import React from "react";
import { Grid, Tooltip, Button, Checkbox } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import "./footer.scss";
import Label from "../../Label/Label";

export default function MapFooter(props) {
  const {
    onClickFooterAction,
    isShowReject,
    isPrevious,
    batchRejection,
    disableSaveAndNext,
    role,
    onClickValidatorView,
    assignToValidator,
    batch_for_qc,
    forValue,
    submitOnReview,
    approvalFor,
  } = props;

  const showValidatorView =
    role === "processor" &&
    process.env.REACT_APP_VALIDATOR_FOR_QC === "true" &&
    batch_for_qc === "true";

  return (
    <Grid container className="MapTableFooter">
      <Grid item md={12} className="MapTbleFbuttons">
        {/* Validator View */}
        {showValidatorView && (
          <div className="checkBox" style={{ paddingRight: 8 }}>
            <Tooltip title="Validator View" arrow>
              <Checkbox
                sx={{ p: 0 }}
                checked={assignToValidator}
                onChange={(e) => onClickValidatorView(e.target.checked)}
                disabled={forValue === "viewOnly"}
              />
            </Tooltip>
            <Label text="Validator View" fontWeight="400" fontSize="13px" />
          </div>
        )}

        {/* Reject */}
        {isShowReject && (
          <div className="checkBox">
            <Tooltip
              title={
                approvalFor === "mappingApproval"
                  ? "Reject Mapping"
                  : "Reject Batch"
              }
              arrow
            >
              <Checkbox
                sx={{ p: 0 }}
                checked={batchRejection}
                onChange={(e) => onClickFooterAction("reject", e)}
                disabled={forValue === "viewOnly"}
              />
            </Tooltip>
            <Label text="Reject" fontWeight="400" fontSize="13px" />
          </div>
        )}

        {/* Buttons */}
        {isPrevious && (
          <Button
            size="medium"
            startIcon={<ArrowBackIosIcon />}
            onClick={() => onClickFooterAction("previous")}
          >
            Previous
          </Button>
        )}

        <Button onClick={() => onClickFooterAction("cancel")}>Cancel</Button>

        <Button
          onClick={() => onClickFooterAction("save")}
          disabled={batchRejection || forValue === "viewOnly"}
        >
          Save
        </Button>
        {submitOnReview ? (
          <Button
            className="btn-contained"
            onClick={() => onClickFooterAction("preview")}
            disabled={disableSaveAndNext || forValue === "viewOnly"}
          >
            Preview
          </Button>
        ) : (
          <Button
            className="btn-contained"
            onClick={() => onClickFooterAction("saveAndNext")}
            disabled={disableSaveAndNext || forValue === "viewOnly"}
          >
            Submit
          </Button>
        )}

        {role === "investigatorValidatior" && (
          <Button
            className="btn-contained"
            onClick={() => onClickFooterAction("saveAndNext")}
            disabled={disableSaveAndNext || forValue === "viewOnly"}
          >
            Submit
          </Button>
        )}
      </Grid>
    </Grid>
  );
}

MapFooter.defaultProps = {
  isShowReject: true,
  batchRejection: false,
  disableSaveAndNext: false,
};
